import { render, staticRenderFns } from "./SimpleTextEditor.vue?vue&type=template&id=0507f894&scoped=true&"
import script from "./SimpleTextEditor.vue?vue&type=script&lang=js&"
export * from "./SimpleTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextEditor.vue?vue&type=style&index=0&id=0507f894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507f894",
  null
  
)

export default component.exports